function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArtMedia = function SvgArtMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 70 70"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70 35c0 19.3-15.7 35-35 35S0 54.3 0 35 15.7 0 35 0s35 15.7 35 35",
    style: {
      fill: "#fd7791"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4 15.5c-10.4 0-18.9 8.8-18.9 19.6S25 54.7 35.4 54.7c1.7 0 3.2-1.5 3.2-3.3 0-.9-.3-1.6-.8-2.2S37 47.9 37 47c0-1.8 1.4-3.3 3.2-3.3h3.7c5.8 0 10.5-4.9 10.5-10.9-.1-9.5-8.6-17.3-19-17.3M23 33.9c-1.6 0-3-1.4-3-3.1s1.3-3.1 3-3.1c1.6 0 3 1.4 3 3.1s-1.4 3.1-3 3.1m7-8.6c-1.6 0-3-1.4-3-3.1s1.3-3.1 3-3.1c1.6 0 3 1.4 3 3.1s-1.3 3.1-3 3.1m9.5 0c-1.6 0-3-1.4-3-3.1s1.3-3.1 3-3.1c1.6 0 3 1.4 3 3.1s-1.4 3.1-3 3.1m7.1 8.6c-1.6 0-3-1.4-3-3.1s1.3-3.1 3-3.1c1.6 0 3 1.4 3 3.1s-1.4 3.1-3 3.1",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgArtMedia;